<div class="switcher" (click)="setValue()">
  <p>{{label}} @if (required) {
    <i class="required-star">*</i>
  }</p>

  <div class="switcher__container" [class.enabled]="val">
    <div class="switcher__toggle"></div>
  </div>
</div>

@if (required) {
  <span class="required-info"><i class="required-star">*</i> {{requiredInfo}}</span>
}

